export const salesRankingQueryKeys = {
  getProductSalesRanking: '/v2/mypage/sales-ranking',
  getAvailableYearMonths: '/v2/mypage/sales-ranking/years-months',
  getLastUpdatedAt: '/v2/mypage/sales-ranking/last-updated-at',
} as const;
